import { useEffect, useState, useCallback, useContext, useMemo } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    CardContent,
    Grid
} from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { contentReportTableApi } from "../../store/analytics/contentReport";
import { ThemeContext } from '../../context/ThemeContext';
import NodataImg from "../../assets/images/noData.png";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import { contentReport } from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import Chart from "../../components/Chart";
import dayjs from "dayjs";

// const columns = [

//     {
//         field: "id",
//         headerName: "Sno.",
//         width: 150,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "title",
//         headerName: "Title",
//         width: 450,
//         filterable: true,
//         filterOperators: getGridStringOperators().filter(
//             (operator) => operator.value === 'equals' | operator.value === 'contains',
//         ),
//         sortable: false,
//     },
//     {
//         field: "subjects",
//         headerName: "Subjects",
//         width: 200,
//         renderCell: (data) => (<>
//             <Typography sx={{ overflowWrap: "anywhere" }}>{Array.isArray(data?.row?.subjects) && data?.row?.subjects.toString()}</Typography>
//         </>),
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "classes",
//         headerName: "Classes",
//         width: 200,
//         renderCell: (data) => (<>
//             <Typography sx={{ overflowWrap: "anywhere" }}>{Array.isArray(data?.row?.classes) && data?.row?.classes.toString()}</Typography>
//         </>),
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "medium",
//         headerName: "Medium",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "category",
//         headerName: "Category",
//         width: 200,
//         renderCell: (data) => (<>
//             <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.category}</Typography>
//         </>),
//         filterable: true,
//         filterOperators: getGridStringOperators().filter(
//             (operator) => operator.value === 'equals' | operator.value === 'contains',
//         ),
//         sortable: false,
//     },
//     {
//         field: "bookmark_count",
//         headerName: "Bookmark count",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "like_count",
//         headerName: "Like count",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "download_count",
//         headerName: "Download count",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "total_time_spent_by_users",
//         headerName: "Total time spent by user",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
//     {
//         field: "avg_time_spent_by_users",
//         headerName: "Average time spent by user",
//         width: 200,
//         filterable: false,
//         sortable: false,
//     },
// ];

const columns = [
    {
        field: "user_id",
        headerName: "User ID",
        width: 100,
        renderCell: (data) => (
            <Typography>{data?.row?.user_id}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "fullname",
        headerName: "Full Name",
        width: 180,
        renderCell: (data) => (
            <Typography>{data?.row?.fullname || "-"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "username",
        headerName: "Username",
        width: 260,
        renderCell: (data) => (
            <Typography sx={{ overflowWrap: "anywhere" }}>
                {data?.row?.username}
            </Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "phone_number",
        headerName: "Phone Number",
        width: 160,
        renderCell: (data) => (
            <Typography>{data?.row?.phone_number || "-"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "content_id",
        headerName: "Content ID",
        width: 120,
        renderCell: (data) => (
            <Typography>{data?.row?.content_id}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "content_title",
        headerName: "Content Title",
        width: 280,
        renderCell: (data) => (
            <Typography sx={{ overflowWrap: "anywhere" }}>
                {data?.row?.content_title}
            </Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "duration",
        headerName: "Total Time Spent (hrs)",
        width: 140,
        renderCell: (data) => (
            <Typography>{data?.row?.duration}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "content_type",
        headerName: "Content Type",
        width: 140,
        renderCell: (data) => (
            <Typography>{data?.row?.content_type}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "like",
        headerName: "Liked",
        width: 100,
        renderCell: (data) => (
            <Typography>{data?.row?.like ? "Yes" : "No"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "bookmark",
        headerName: "Bookmarked",
        width: 130,
        renderCell: (data) => (
            <Typography>{data?.row?.bookmark ? "Yes" : "No"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "enrollment_date",
        headerName: "Enrollment Date",
        width: 180,
        renderCell: (data) => (
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.enrollment_date && dayjs(data?.row?.enrollment_date).format("YYYY-MM-DD")}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "grade",
        headerName: "Grade",
        width: 100,
        renderCell: (data) => (
            <Typography>{data?.row?.grade || "-"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "passed",
        headerName: "Passed",
        width: 100,
        renderCell: (data) => (
            <Typography>{data?.row?.passed ? "Yes" : "No"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "platform",
        headerName: "Platform",
        width: 120,
        renderCell: (data) => (
            <Typography>{data?.row?.platform}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "passing_date",
        headerName: "Passing Date",
        width: 180,
        renderCell: (data) => (
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.passing_date && dayjs(data?.row?.passing_date).format("YYYY-MM-DD")}</Typography>

        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "certificate_generation",
        headerName: "Certificate Generation",
        width: 150,
        renderCell: (data) => (
            <Typography>{data?.row?.certificate_generation ? "Generated" : "Not Generated"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },
    {
        field: "feedback_rating",
        headerName: "Feedback Rating",
        width: 120,
        renderCell: (data) => (
            <Typography>{data?.row?.feedback_rating || "-"}</Typography>
        ),
        filterable: false,
        sortable: false,
    },

];

export default function ContentConsumptionNonGraded({ graphData, type, startDate, monthDaily, endDate, module, region, state, isMaskingEnabled }) {
    const [numofresources, setNumofresources] = useState({ l1: true, l2: true, l3: true, l4: true });
    const [teacherRegister, setTeacherRegistration] = useState({
        l1: true,
        l2: true,
        l3: true,
        l4: true,
    });

    const transformGraphData = useMemo(() => {
        let buckets = [];
        if (graphData?.data && graphData.data.length > 0 && Array.isArray(graphData.data[0].buckets)) {
            buckets = [...graphData.data[0].buckets].sort((a, b) => new Date(a.date) - new Date(b.date));
        }

        return buckets.map((item) => {
            let formattedName = item.label || item.date;
            if (type === "daily") {
                formattedName = dayjs(item.date).format("D MMM");
            } else if (type === "monthly") {
                formattedName = dayjs(item.date).format("MMMM");
            }

            const dataPoint = { name: formattedName };
            dataPoint["Total New Modules Added"] = item.total_modules || 0;
            dataPoint["Accessed Modules"] = item.accessed_modules || 0;
            dataPoint["Completed Modules"] = item.completed_modules || 0;
            dataPoint["Added To Agenda"] = item.added_to_agenda || 0;
            return dataPoint;
        });
    }, [graphData, monthDaily]);

    const toggleNumofresources = useCallback((key) => {
        setNumofresources(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const contentReportTable = useSelector((state) => state?.contentReportTable);
    const { result: tableResult, loading: tableLoading, total } = contentReportTable;
    const dispatch = useDispatch();
    const [isDownload, setIsDownload] = useState(false)

    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);

    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    useEffect(() => {
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;

        const query = {
            page: paginationModel?.page + 1,
            page_size: paginationModel?.pageSize,
            field: firstItem.field || '',
            module_name: module,
            content_type: module,
            city: region,
            state: state,
            startDate: startDate,
            endDate: endDate,
            enable_masking: isMaskingEnabled,
            operator: firstItem.operator || (quickFilterValues && "contains") || '',
            value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
        };
        dispatch(contentReportTableApi(query));
    }, [dispatch, queryOptions, paginationModel, module, region, state, startDate, endDate, isMaskingEnabled]);

    return (<>
        <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
            <Typography variant="h3">Content Consumption Graph</Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
            <Grid container spacing={1}>
                {tableResult?.module_statistics && Object.entries(tableResult.module_statistics ?? {}).map(([key, value], index) => {
                    return (
                        <Grid item xs={6} sm={6} md={6} lg={3} mb={1} key={key}>
                            <Box
                                className="customCard1"
                                sx={{
                                    transition: "none !important",
                                    "&:hover": {
                                        transform: "none !important",
                                    },
                                }}
                            >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Stack>
                                        <Typography sx={{ textTransform: "capitalize" }}>
                                            {key?.replaceAll("_", " ")}
                                        </Typography>
                                        <Typography variant="h4" fontWeight={600}>
                                            {value ?? 0}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Grid>
                    )
                })}
            </Grid>
        </Stack>



        <Stack sx={{ my: 2, padding: "10px" }} >
            <Card>
                <CardContent>
                    <Chart
                        type={"line"}
                        height={500}
                        data={transformGraphData}
                        module={"individualContent"}
                        lineState={teacherRegister}
                    />
                </CardContent>
            </Card>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
            <Typography variant="h3">Content Consumption</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
            <DataGridComponent
                disableColumnMenu
                disableColumnSorting
                loading={tableLoading}
                rowCount={total}
                pageSize={paginationModel?.pageSize}
                onPageSizeChange={(newPageSize) => {
                    setPaginationModel({
                        ...paginationModel,
                        pageSize: newPageSize,
                    })
                }}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sx={{
                    height: 500
                }}
                getRowId={(row) => `${row.user_id}-${row.content_id}-${row.created_at}`}
                rows={tableResult?.results || []} //cause BE change the structure of response and added card data one level above the results array for table -yash :D
                getRowSpacing={getRowSpacing}
                columns={columns}
                onFilterModelChange={onFilterChange}
                slots={{
                    noRowsOverlay: () => (
                        <Box className="noData">
                            <img src={NodataImg} alt="no data found" />
                        </Box>
                    ),
                    toolbar: (props) =>
                    (CustomGridToolbar({
                        ...props,
                        moduleType: "contentConsumption",
                        queryOptions,
                        paginationModel,
                        isDownload,
                        setIsDownload,
                        apiUrl: contentReport,
                        hasfilter: false,
                        module,
                        region,
                        state,
                        startDate,
                        endDate,
                        permissionModule: "analytics_dashboard"
                    })),
                }}
                slotProps={{
                    loadingOverlay: {
                        variant: 'linear-progress',
                        noRowsVariant: 'linear-progress',
                    },
                    toolbar: {
                        showQuickFilter: true,
                    },
                    pagination: {
                        labelDisplayedRows: () => null,
                        sx: {
                            "& .MuiTablePagination-actions": {
                                marginLeft: -5
                            }
                        }
                    }
                }}
            />
        </Stack>
        <BackdropUI open={isDownload} />
    </>)
}